/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */

//// CONTROLLER ////
export class OptimizeDialogController {
    public destinationsMissing: any;
    public destinationsUnnecessary: any;

    static get $inject() {
        return ['$mdDialog', 'optimizedObjects'];
    }

    constructor(
        public $mdDialog: any,
        public optimizedObjects: any
    ) {
        let vm = this;
        /* BINDABLE: DATA */
        vm.destinationsMissing = [];
        vm.destinationsUnnecessary = [];
    }

    $onInit() {
        let vm = this;
        //Do init things
        vm.destinationsMissing =
            vm.optimizedObjects && vm.optimizedObjects.missingSpots
                ? Object.keys(vm.optimizedObjects.missingSpots)
                : [];
        vm.destinationsUnnecessary =
            vm.optimizedObjects && vm.optimizedObjects.unnecessarySpots
                ? Object.keys(vm.optimizedObjects.unnecessarySpots)
                : [];
    }

    //START FUNCTION BLOCK
    cancel() {
        let vm = this;
        vm.$mdDialog.cancel();
    }

    submit() {
        let vm = this;
        vm.$mdDialog.hide(true);
    }
}
